var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""},on:{"click":function($event){return _vm.redirect(_vm.author)}}},[_c('v-img',{staticClass:"align-end",attrs:{"src":require('../../assets/backgrounds/' + _vm.author.image),"width":"100%","height":"250"}},[_c('p',{staticClass:"text-title white--text ml-3 mb-2"},[_vm._v(_vm._s(_vm.author.name))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }